import React from 'react';
import * as yup from 'yup';
import { richTextFromCMSSchema } from '../schemas';

export const component = ({ body }) => <>{body}</>;

export const schema = yup.object({
  body: richTextFromCMSSchema,
});
